import { useDispatch, useSelector } from "react-redux";
import { actionCreators, State } from "@App/state";
import { bindActionCreators } from "@reduxjs/toolkit";
import { useState } from "react";

export const useVehicleReturnContractStepDefinition = (onSubmit: () => void) => {
  const dispatch = useDispatch();
  const { setNumberPlate } = bindActionCreators(actionCreators, dispatch);
  const numberPlate = useSelector((state: State) => state.orders.numberPlate);

  const [contractNumber, setContractNumber] = useState<string>("");

  return {
    contractNumber,
    numberPlate,
    setContractNumber,
    setNumberPlate,
    onSubmit,
    stepGoBackLinkTitle: "",
  };
};
